import Create from './Create'
import Edit from './Edit'
import Overview from './Overview'
import Base from './Base'

export default {
    Create,
    Edit,
    Overview,
    Base
}


// WEBPACK FOOTER //
// ./src/views/admin/coupons/index.js